import InfluencerDetail from "./influencer/InfluencerDetail";
import InfluencerList from "./influencer/InfluencerList";

import CouponDetail from "./coupon/CouponDetail";
import CouponList from "./coupon/CouponList";

import RewardDetail from "./rewards/RewardDetail";
import RewardList from "./rewards/RewardList";
import BenefitList from "./promotions/benefits/BenefitList.vue";
import BenefitDetail from "./promotions/benefits/BenefitDetail.vue";

import SubscriptionGiftCouponDetail from "./promotions/subscription-gift-coupon/SubscriptionGiftCouponDetail";
import SubscriptionGiftCouponList from "./promotions/subscription-gift-coupon/SubscriptionGiftCouponList";

export default [
  // Benefit
  {
    path: '/benefit',
    name: 'benefit-list',
    meta: {
      authorizedRoles: ['marketing', 'financial'],
    },
    component: BenefitList,
  },
  {
    path: '/benefit/new',
    name: 'benefit-new',
    meta: {
      authorizedRoles: ['marketing', 'financial'],
    },
    component: BenefitDetail,
  },
  {
    path: '/benefit/:id',
    name: 'benefit-detail',
    meta: {
      authorizedRoles: ['marketing', 'financial'],
    },
    component: BenefitDetail,
  },
  // Subscription Gift Coupon
  {
    path: '/subscription-gift-coupon',
    name: 'subscription-gift-coupon-list',
    meta: {
      authorizedRoles: ['marketing', 'financial'],
    },
    component: SubscriptionGiftCouponList,
  },
  {
    path: '/subscription-gift-coupon/new',
    name: 'subscription-gift-coupon-new',
    meta: {
      authorizedRoles: ['marketing', 'financial'],
    },
    component: SubscriptionGiftCouponDetail,
  },
  {
    path: '/subscription-gift-coupon/:id',
    name: 'subscription-gift-coupon-detail',
    meta: {
      authorizedRoles: ['marketing', 'financial'],
    },
    component: SubscriptionGiftCouponDetail,
  },
  // Coupon
  {
    path: '/coupons',
    name: 'coupon-list',
    meta: {
      authorizedRoles: ['marketing'],
    },
    component: CouponList,
  },
  {
    path: '/coupons/new',
    name: 'coupon-new',
    meta: {
      authorizedRoles: ['marketing'],
    },
    component: CouponDetail,
  },
  {
    path: '/coupons/:id',
    name: 'coupon-detail',
    meta: {
      authorizedRoles: ['marketing'],
    },
    component: CouponDetail,
  },
  // Partners
  {
    path: '/partners',
    name: 'influencer-list',
    component: InfluencerList,
    meta: {
      authorizedRoles: ['marketing'],
    },
  },
  {
    path: '/partners/new',
    name: 'influencer-new',
    component: InfluencerDetail,
    meta: {
      authorizedRoles: ['marketing'],
    },
  },
  {
    path: '/partners/:id',
    name: 'influencer-detail',
    component: InfluencerDetail,
    meta: {
      authorizedRoles: ['marketing'],
    },
  },
  // Reward
  {
    path: '/marketing/rewards/reward',
    name: 'reward-list',
    component: RewardList,
    meta: {
      authorizedRoles: ['marketing', 'operations-lead'],
    },
  },
  {
    path: '/marketing/rewards/reward/new',
    name: 'reward-new',
    component: RewardDetail,
    meta: {
      authorizedRoles: ['marketing'],
    },
  },
  {
    path: '/marketing/rewards/reward/:id',
    name: 'reward-detail',
    component: RewardDetail,
    meta: {
      authorizedRoles: ['marketing'],
    },
  },
];
